// import { CreateEmitter, SearchEmitter, UpdateEmitter } from '@/types/emitter'/
import { SearchParams } from '@/types/common'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

const twoWireApi = {
  getStateEnum(interfaceId: string) {
    const url = `/api/twowire/stateenum?interfaceId=${interfaceId}`
    return axiosClient.get(url)
  },

  getAll(searchParams: SearchParams) {
    const url = '/api/twowire'
    return axiosClient.get(url + queryStringify(searchParams))
  },
  getById(interfaceId: string) {
    const url = `/api/twowire/${interfaceId}/info`
    return axiosClient.get(url)
  },

  swtichTwoWireMode(
    params: {
      interfaceId: string
      freq: number
    },
    state: string,
  ) {
    const url = `/api/twowire/state/${state}${queryStringify(params)}`
    return axiosClient.post(url)
  },

  getTwoWireTest(interfaceId: string) {
    const url = `/api/twowire/test?interfaceId=${interfaceId}`
    return axiosClient.get(url)
  },

  getListLeaks(interfaceId: string) {
    const url = `/api/twowire/leaks?interfaceId=${interfaceId}`
    return axiosClient.get(url)
  },

  getListVoltages(interfaceId: string) {
    const url = `/api/twowire/voltages?interfaceId=${interfaceId}&maxCount=15`
    return axiosClient.get(url, { timeout: 60000 })
  },
}

export default twoWireApi
